import { createContext, useContext, useState, useEffect } from "react";
import i18n from "../i18n";
import { rtlLanguages, localeMap } from "@/constants/miscConstants";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  // Load from localStorage ONCE — single source of truth
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem("language") || "en";
  });
  const [direction, setDirection] = useState("ltr");
  const [antdLocale, setAntdLocale] = useState(localeMap[language]);
  const [isRTL, setIsRTL] = useState(false);

  useEffect(() => {
    const updateLanguage = async () => {
      await i18n.changeLanguage(language);
      const isRtl = rtlLanguages.includes(language);
      document.documentElement.dir = isRtl ? "rtl" : "ltr";
      setDirection(isRtl ? "rtl" : "ltr");
      setIsRTL(isRtl ? true : false);
      setAntdLocale(localeMap[language]);
      localStorage.setItem("language", language);
    };

    updateLanguage();
  }, [language]);

  return (
    <LanguageContext.Provider
      value={{ language, setLanguage, direction, antdLocale, isRTL }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
